import type { Game } from 'chessboard/model/game/types';
import type { API } from 'chessboard/api/config/types';
import JCE from '@chesscom/js-chess-engine';

/**
 * Create the getLegalMoves method.
 */
export function createGetLegalMoves(context: API.Context) {
  /**
   * Get an array of all legal moves.
   */
  return function getLegalMoves(): Game.Move.Model[] {
    const { game } = context;

    return JCE.getLegalMoves({ game } as any);
  };
}
